import React from 'react'
import "./aboutContent.css"
import { Link } from 'react-router-dom'
import pro1 from "../Assets/me.jpg"
function AboutContent() {
  return (
    <div className='about'>
        <div className='left'>
            <h1>Who Am I ?</h1>
            <p>I am a Jr. Front-End Developer. My aim is to hired for professional job that I can work for that company to 
                succesfully fulfill the vision of the company and at the same time I want to improve myself.  </p>
                <Link to="/contact">
                    <button className='btn'>Contact</button>
                </Link>
                <p>I am a graduate of Yildiz Technical University's Civil Engineering program in 2023. During my undergraduate studies, I aimed to continuously improve myself by participating in various trainings and seminars, and I am someone who enjoys teamwork, research, reading, and constantly learning new technologies. In the final year of my university education, I attended the "Introduction to Software Development with Patika" program and worked on projects in areas such as HTML, CSS, JavaScript, React, TypeScript, Bootstrap, and Figma. Between 2022 and 2023, I initiated a project called "Hypance" with the team I met during the Patika training. Through this project, I gained 6 months of experience with JavaScript and 6 months with TypeScript (primarily focused on React). With these experiences, I aim to continue my career as a Web Interface Designer and Front End Developer. Thank you for your interest. If you find it necessary, I would like to have a mutual discussion to provide more detailed information. I appreciate your attention in advance.</p>
                <p>Regards.</p>
        </div>
        <div className='right'>
            <div className='img-container'>
            <div className='img-stack top'>
                <img className='img' src={pro1} alt='me' />
            </div>
            </div>
        </div>
    </div>
  )
}

export default AboutContent